import { Suspense } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import { PageLoader } from '@components/common';
import ErrorBoundary from '@components/common/ErrorBoundary';
import NavBottom from '@components/common/NavBottom/NavBottom';
import NavBottomTally from '@components/common/NavBottomTally/NavBottomTally';
import RouteWrapper from './RouteWrapper';
import { routes } from './routeConfig';
import { STORAGE_KEYS } from '@constants';

// Check if user is authenticated
const isAuthenticated = () => {
  try {
    const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
    return !!(token && token.trim() !== '');
  } catch (error) {
    console.warn('Error accessing localStorage:', error);
    return false;
  }
};

// Homepage component that handles auth redirect
const HomepageRoute = () => {
  const homepageRoute = routes.find(route => route.path === '/');

  return (
    <RouteWrapper
      component={homepageRoute.component}
      layout={homepageRoute.layout}
      protected={homepageRoute.protected}
    />
  );
};

// Resets the error boundary on navigation so one crashed page doesn't block the app
const RouteErrorBoundary = ({ children }) => {
  const location = useLocation();
  return <ErrorBoundary resetKey={location.pathname}>{children}</ErrorBoundary>;
};

const AppRouter = () => {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <RouteErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            {/* Special route for homepage with auth redirect */}
            <Route path="/" element={<HomepageRoute />} />

            {/* Other routes */}
            {routes
              .filter(route => route.path !== '/')
              .map(route => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    <RouteWrapper
                      component={route.component}
                      layout={route.layout}
                      protected={route.protected}
                    />
                  }
                />
              ))}
          </Routes>
          <NavBottom />
          <NavBottomTally />
        </Suspense>
      </RouteErrorBoundary>
    </BrowserRouter>
  );
};

export default AppRouter;
